var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaygroup = function SvgPlaygroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55 0C24.663 0 0 24.663 0 55s24.663 55 55 55 55-24.663 55-55S85.337 0 55 0Zm0 105.368C27.21 105.368 4.632 82.79 4.632 55 4.632 27.21 27.21 4.632 55 4.632c27.79 0 50.368 22.578 50.368 50.368 0 27.79-22.578 50.368-50.368 50.368Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.927 51.295 45.969 31.379c-2.895-1.853-6.716.232-6.716 3.705v39.948c0 3.473 3.821 5.558 6.716 3.705l31.958-19.916c2.778-1.852 2.778-5.79 0-7.526Z"
  })));
};
export default SvgPlaygroup;